import Constants from "../Util/constant";
import { DashboardPage } from "./Dashboard/dashboard_page";
import { Route, Routes } from "react-router-dom";
import { ConfigurationPage } from "./Email/configuration_page";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Button, Loader, checkAccess } from "../Util/common";
import { TourPage } from "./ScheduledEvents/tour_page";
import { ContractPage } from "./Contract/contarct_page";
import { AppConfigurationPage } from "./AppConfig/app_configuration_page";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUser } from "./layout_slice";
import Revenue from "./Dashboard/Revenue/Revenue";
import Sales from "./Dashboard/Sales/Sales";
import CountsOnLead from "./Dashboard/CountsOnLead/CountsOnLead";
import CustomerStatisfaction from "./Dashboard/CustomerStatisfation/CustomerStatisfaction";
import RingCentralIndex from "./Dashboard/RingCentral/RingCentralIndex";
import FeedbackIndex from "./Feedback/Index";
import CommonDropdown from "./Dashboard/CommonDropdown";
import CountonLeadReport from "./Reports/ReportIndex";
import Execution from "./Dashboard/Execution/Execution";
import { BannerPage } from "./Banner/banner_Page";

import { Gallery_Main } from "./Gallery/Gallery_Main";
import { Testimonials } from "./Testimonials/Testimonials";

import { WelcomeSection } from "./WelcomeSection/welcomeSection";
import { UpcomingEvents } from "./UpcomingEvents/UpcomingEvents";
import { HighlightsAwards } from "./Highlights&Award/HighlightsAwards";
import { AboutUs } from "./AboutUS/AboutUs";
import { Contact } from "./Contact/Contact";
import { FAQ } from "./FAQ/FAQ";

import { PrivacyTerms } from "./Privacy&Terms/PrivacyTerms";
import { Packages } from "./Packages/Packages";
import { EventTips } from "./EventTips/EventTips";
import { Blog } from "./Blogs/Blog";
import { Services } from "./Services/Services";
import { VendorServices } from "./VendorServices/VendorServices";
import { RentalHighlights } from "./Rental/RentalHighlights/RentalHighlights";
// import { Facilities } from "./Facilities/Facilities";
import { FacilityList } from "./Facilities/FacilityList";
import { Videos } from "./Videos/Videos";
import { RentalServiceDetails } from "./Rental/RentalServiceDetails/RentalServiceDetails";
import {
  RentalGuideline,
  RentalGuidline,
} from "./Rental/RentalGuidline/RentalGuideline";
import Myballroom from "./Myballroom/Myballroom";
import { Settings } from "./Contact/Settings";
import { Amenities } from "./Amenities/Amenities";
import { VenueHighlights } from "./VenueHighlights/VenueHighlights";
import { RequestedVendor } from "./VendorRequest/requestedVendor";
import RegisteredVendorMobile from "./VendorRequest/RegisteredVendorMobile";
import rentalCategory from "./Rental/RentalCategory/rentalCategory";
import { vendorRequest } from "./VendorRequest/vendorRequest";
import RentalCandI from "./Rental/Rental CandI/rentalCandI";
import DecorationCandI from "./Decoration/Decoration CandI/decorationCandI";
import DecorationItem from "./Decoration/DecorationItem/decorationItem";
import Payment_Methods from "./PaymentMethods/paymentMethods";
import Decoration from "./Decoration/DecorationItem/decoration";
import { eventTips_Page } from "./EventTips/eventTips_Page";
import { EventTipsImage } from "./EventTips/EventTipsImage";

export const Layout = () => {
  const dispatch = useDispatch();
  const activeMenu = window.location.href.split("/").pop();
  const { loading } = useSelector((state) => state.layout);

  useEffect(() => {
    fetchUser();
    var $slimScrolls = $(".slimscroll");

    if ($slimScrolls.length > 0) {
      $slimScrolls.slimScroll({
        height: "auto",
        width: "100%",
        position: "right",
        size: "7px",
        color: "#ccc",
        wheelStep: 10,
        touchScrollStep: 100,
      });
      var wHeight = $(window).height() - 60;
      $slimScrolls.height(wHeight);
      $(".sidebar .slimScrollDiv").height(wHeight);
      $(window).resize(function () {
        var rHeight = $(window).height() - 60;
        $slimScrolls.height(rHeight);
        $(".sidebar .slimScrollDiv").height(rHeight);
      });
    }
  }, []);

  const fetchUser = () => {
    let search = window.location.search;
    const queryParams = new URLSearchParams(search);
    const userId = queryParams.get("user");
    dispatch(getUser(userId));
  };

  // if (loading) {
  //   return (
  //     <>
  //       <div id="loader">
  //         <div class="preloader">
  //           <div class="vertical-centered-box">
  //             <div class="content">
  //               <div class="loader-circle"></div>
  //               <div class="loader-line-mask">
  //                 <div class="loader-line"></div>
  //               </div>
  //               <img src="%PUBLIC_URL%/assets/images/preloader.png" alt="" />
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     </>
  //   );
  // }

  return (
    <div className="main-wrapper">
      {/* Header */}
      <div className="header">
        {/* Logo */}
        <div className="header-left">
          <a href="#" className="logo">
            <img src="assets/img/logo.png" width="auto" height="60" alt="" />
          </a>
        </div>
        {/* /Logo */}

        <a id="toggle_btn" href="#">
          <span className="bar-icon">
            <span></span>
            <span></span>
            <span></span>
          </span>
        </a>

        {/* Header Title */}
        <div className="page-title-box">
          <h3>{Constants.appName}</h3>
        </div>
        {/* /Header Title */}

        <a
          id="mobile_btn"
          className="mobile_btn"
          href="#sidebar"
          onClick={() => {
            $(".main-wrapper").toggleClass("slide-nav");
          }}
        >
          <i className="fa fa-bars"></i>
        </a>

        {/* Header Menu */}
        <ul className="nav user-menu">
          {/* Notifications */}
          {/* <li className="nav-item dropdown">
            <a
              href="#"
              className="dropdown-toggle nav-link"
              data-bs-toggle="dropdown"
            >
              <i className="fa fa-bell-o"></i>{" "}
              <span className="badge rounded-pill">3</span>
            </a>
            <div className="dropdown-menu notifications">
              <div className="topnav-dropdown-header">
                <span className="notification-title">Notifications</span>
                <a href="#" className="clear-noti">
                  {" "}
                  Clear All{" "}
                </a>
              </div>
              <div className="noti-content">
                <ul className="notification-list">
                  <li className="notification-message">
                    <a href="activities.html">
                      <div className="media d-flex">
                        <span className="avatar flex-shrink-0">
                          <img alt="" src="assets/img/profiles/avatar-02.jpg" />
                        </span>
                        <div className="media-body flex-grow-1">
                          <p className="noti-details">
                            <span className="noti-title">John Doe</span> added
                            new task{" "}
                            <span className="noti-title">
                              Patient appointment booking
                            </span>
                          </p>
                          <p className="noti-time">
                            <span className="notification-time">
                              4 mins ago
                            </span>
                          </p>
                        </div>
                      </div>
                    </a>
                  </li>
                  <li className="notification-message">
                    <a href="activities.html">
                      <div className="media d-flex">
                        <span className="avatar flex-shrink-0">
                          <img alt="" src="assets/img/profiles/avatar-03.jpg" />
                        </span>
                        <div className="media-body flex-grow-1">
                          <p className="noti-details">
                            <span className="noti-title">Tarah Shropshire</span>{" "}
                            changed the task name{" "}
                            <span className="noti-title">
                              Appointment booking with payment gateway
                            </span>
                          </p>
                          <p className="noti-time">
                            <span className="notification-time">
                              6 mins ago
                            </span>
                          </p>
                        </div>
                      </div>
                    </a>
                  </li>
                  <li className="notification-message">
                    <a href="activities.html">
                      <div className="media d-flex">
                        <span className="avatar flex-shrink-0">
                          <img alt="" src="assets/img/profiles/avatar-06.jpg" />
                        </span>
                        <div className="media-body flex-grow-1">
                          <p className="noti-details">
                            <span className="noti-title">Misty Tison</span>{" "}
                            added{" "}
                            <span className="noti-title">Domenic Houston</span>{" "}
                            and <span className="noti-title">Claire Mapes</span>{" "}
                            to project{" "}
                            <span className="noti-title">
                              Doctor available module
                            </span>
                          </p>
                          <p className="noti-time">
                            <span className="notification-time">
                              8 mins ago
                            </span>
                          </p>
                        </div>
                      </div>
                    </a>
                  </li>
                  <li className="notification-message">
                    <a href="activities.html">
                      <div className="media d-flex">
                        <span className="avatar flex-shrink-0">
                          <img alt="" src="assets/img/profiles/avatar-17.jpg" />
                        </span>
                        <div className="media-body flex-grow-1">
                          <p className="noti-details">
                            <span className="noti-title">Rolland Webber</span>{" "}
                            completed task{" "}
                            <span className="noti-title">
                              Patient and Doctor video conferencing
                            </span>
                          </p>
                          <p className="noti-time">
                            <span className="notification-time">
                              12 mins ago
                            </span>
                          </p>
                        </div>
                      </div>
                    </a>
                  </li>
                  <li className="notification-message">
                    <a href="activities.html">
                      <div className="media d-flex">
                        <span className="avatar flex-shrink-0">
                          <img alt="" src="assets/img/profiles/avatar-13.jpg" />
                        </span>
                        <div className="media-body flex-grow-1">
                          <p className="noti-details">
                            <span className="noti-title">Bernardo Galaviz</span>{" "}
                            added new task{" "}
                            <span className="noti-title">
                              Private chat module
                            </span>
                          </p>
                          <p className="noti-time">
                            <span className="notification-time">
                              2 days ago
                            </span>
                          </p>
                        </div>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
              <div className="topnav-dropdown-footer">
                <a href="activities.html">View all Notifications</a>
              </div>
            </div>
          </li> */}
          {/* /Notifications */}

          {/* <li className="nav-item dropdown has-arrow main-drop">
            <a
              href="#"
              className="dropdown-toggle nav-link"
              data-bs-toggle="dropdown"
            >
              <span style={{ marginLeft: "3px" }}>
                {localStorage.getItem("Username") || ""}
              </span>
            </a>
            <div className="dropdown-menu">
              <a className="dropdown-item" href={`${baseURL}/Settings`}>
                Change Password
              </a>
              <a className="dropdown-item" href={`${baseURL}Admin?Islogout=1`}>
                Logout
              </a>
            </div>
          </li> */}
        </ul>
        {/* /Header Menu */}

        {/* Mobile Menu */}
        {/* <div className="dropdown mobile-user-menu">
          <a
            href="#"
            className="nav-link dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa fa-ellipsis-v"></i>
          </a>
          <div className="dropdown-menu dropdown-menu-right">
            <a className="dropdown-item" href={`${baseURL}/Settings`}>
              Change Password
            </a>
            <a className="dropdown-item" href={`${baseURL}Admin?Islogout=1`}>
              Log out
            </a>
          </div>
        </div> */}
        {/* /Mobile Menu */}
      </div>
      {/* /Header */}

      {/* Sidebar */}
      <div className="sidebar" id="sidebar">
        <div>
          <div className="sidebar-inner slimscroll">
            <div id="sidebar-menu" className="sidebar-menu">
              <ul>
                {checkAccess("DASHBOARDVIEW") && (
                  <>
                    <li className="menu-title">
                      <span>Dashboard</span>
                    </li>
                    <li
                      id="Sales"
                      className={activeMenu == "Sales" ? "active" : ""}
                    >
                      <a href="/Sales">
                        <i className="las la-file-invoice-dollar"></i>{" "}
                        <span>Sales</span>{" "}
                      </a>
                    </li>
                    <li
                      id="Revenue"
                      className={activeMenu == "revenue" ? "active" : ""}
                    >
                      <a href="/revenue">
                        <i className="las la-dollar-sign"></i>
                        <span>Revenue</span>{" "}
                      </a>
                    </li>
                    <li
                      id="Execution"
                      className={activeMenu == "Execution" ? "active" : ""}
                    >
                      <a href="/Execution">
                        <i className="las la-money-check"></i>{" "}
                        <span>Execution</span>{" "}
                      </a>
                    </li>
                    <li
                      id="RingCentral"
                      className={activeMenu == "RingCentral" ? "active" : ""}
                    >
                      <a href="/RingCentral">
                        <i className="las la-phone-volume"></i>{" "}
                        <span>RingCentral</span>{" "}
                      </a>
                    </li>
                    <li
                      id="CountLead"
                      className={activeMenu == "CountLead" ? "active" : ""}
                    >
                      <a href="/CountLead">
                        <i className="las la-user-check"></i>
                        <span>Counts on Lead Status</span>{" "}
                      </a>
                    </li>{" "}
                    <li
                      id="CustomerSatisfaction"
                      className={
                        activeMenu == "CustomerSatisfaction" ? "active" : ""
                      }
                    >
                      <a href="/CustomerSatisfaction">
                        <i className="las la-handshake"></i>
                        <span>Customer satisfaction</span>{" "}
                      </a>
                    </li>
                  </>
                )}
                {checkAccess("FEEDBACKVIEW") && (
                  <>
                    <li className="menu-title">
                      <span>Feedback</span>
                    </li>
                    <li
                      id="FeedbackList"
                      className={activeMenu == "FeedbackList" ? "active" : ""}
                    >
                      <a href="/FeedbackList">
                        <i className="las la-comment"></i> <span>Feedback</span>
                      </a>
                    </li>
                  </>
                )}
                {(checkAccess("APPCONFIGVIEW") ||
                  checkAccess("EMAILCONFIGVIEW")) && (
                  <li className="menu-title">
                    <span>Configuration</span>
                  </li>
                )}

                {checkAccess("APPCONFIGVIEW") && (
                  <>
                    {/* {(checkAccess("APPCONFIGVIEW") ||
                  checkAccess("EMAILCONFIGVIEW")) && (
                  <li className="menu-title">
                    <span>Reports</span>
                  </li>
                )}
              
                <li>
                  <a style={{ cursor: "pointer" }} href="/Report_Index">
                    <i className="las la-user-check"></i>
                    <span>Reports</span>{" "}
                  </a>
                </li>{" "} */}
                    <li
                      id="aboutUs"
                      className={activeMenu == "AboutUs" ? "active" : ""}
                    >
                      <a href="/AboutUs">
                        <i className="la la-info-circle"></i>{" "}
                        <span>About Us</span>
                      </a>
                    </li>

                    <li
                      id="amenities"
                      className={activeMenu == "Amenities" ? "active" : ""}
                    >
                      <a href="/Amenities">
                        <i className="la la-tree"></i> <span>Amenities</span>
                      </a>
                    </li>
                    <li
                      id="app-configuration"
                      className={
                        activeMenu == "app-configuration" ? "active" : ""
                      }
                    >
                      <a href="/app-configuration">
                        <i className="las la-cog"></i>{" "}
                        <span>Application Config</span>
                      </a>
                    </li>
                    <li
                      id="banner"
                      className={activeMenu == "Banner" ? "active" : ""}
                    >
                      <a href="/Banner">
                        <i className="la la-certificate"></i>{" "}
                        <span>Banner</span>
                      </a>
                    </li>
                    <li
                      id="blog"
                      className={activeMenu == "Blog" ? "active" : ""}
                    >
                      <a href="/Blog">
                        <i className="la la-newspaper"></i> <span>Blogs</span>
                      </a>
                    </li>
                    {checkAccess("EMAILCONFIGVIEW") && (
                      <li
                        id="configuration"
                        className={
                          activeMenu == "email-configuration" ? "active" : ""
                        }
                      >
                        <a href="/email-configuration">
                          <i className="las la-envelope"></i>{" "}
                          <span>Email Config</span>
                        </a>
                      </li>
                    )}
                    <li
                      id="eventTips"
                      className={activeMenu == "EventTipsPage" ? "active" : ""}
                    >
                      <a href="/EventTipsPage">
                        <i className="las la-lightbulb"></i>{" "}
                        <span>Event Tips</span>
                      </a>
                    </li>

                    <li
                      id="faq"
                      className={activeMenu == "F-A-Q" ? "active" : ""}
                    >
                      <a href="/F-A-Q">
                        <i className="la la-question-circle"></i>{" "}
                        <span>FAQ</span>
                      </a>
                    </li>

                    <li
                      id="gallery_Main"
                      className={activeMenu == "Gallery_Main" ? "active" : ""}
                    >
                      <a href="/Gallery_Main">
                        <i className="la la-th-large"></i> <span>Gallery</span>
                      </a>
                    </li>

                    <li
                      id="highlightsAwards"
                      className={
                        activeMenu == "HighlightsAwards" ? "active" : ""
                      }
                    >
                      <a href="/HighlightsAwards">
                        <i className="la la-medal"></i>{" "}
                        <span>Highlights & Awards</span>
                      </a>
                    </li>

                    <li
                      id="myBallroom"
                      className={activeMenu == "MyBallroom" ? "active" : ""}
                    >
                      <a href="/MyBallroom">
                        <i className="la la-mobile"></i> <span>MyBallroom</span>
                      </a>
                    </li>

                    <li
                      id="packages"
                      className={activeMenu == "Packages" ? "active" : ""}
                    >
                      <a href="/Packages">
                        <i className="la la-box"></i> <span>Packages</span>
                      </a>
                    </li>

                    <li
                      id="privacyTerms"
                      className={activeMenu == "PrivacyTerms" ? "active" : ""}
                    >
                      <a href="/PrivacyTerms">
                        <i className="la la-copyright"></i>{" "}
                        <span>Policies</span>
                      </a>
                    </li>

                    <li
                      id="services"
                      className={activeMenu == "Services" ? "active" : ""}
                    >
                      <a href="/Services">
                        <i className="la la-truck"></i> <span>Services</span>
                      </a>
                    </li>

                    <li
                      id="Settings"
                      className={activeMenu == "Settings" ? "active" : ""}
                    >
                      <a href="/Settings">
                        <i className="la la-phone"></i> <span>Settings</span>
                      </a>
                    </li>

                    <li
                      id="testimonials"
                      className={activeMenu == "Testimonials" ? "active" : ""}
                    >
                      <a href="/Testimonials">
                        <i className="las la-comment-alt"></i>{" "}
                        <span>Testimonials</span>
                      </a>
                    </li>

                    <li
                      id="upcomingEvents"
                      className={activeMenu == "UpcomingEvents" ? "active" : ""}
                    >
                      <a href="/UpcomingEvents">
                        <i className="la la-clock-o"></i>{" "}
                        <span>Upcoming Events</span>
                      </a>
                    </li>

                    <li
                      id="facilityList"
                      className={activeMenu == "FacilityList" ? "active" : ""}
                    >
                      <a href="/FacilityList">
                        <i className="la la-building"></i> <span>Venues</span>
                      </a>
                    </li>
                    <li
                      id="VenueHighlights"
                      className={
                        activeMenu == "VenueHighlights" ? "active" : ""
                      }
                    >
                      <a href="/VenueHighlights">
                        <i className="la la-camera"></i>{" "}
                        <span>Venue Highlights</span>
                      </a>
                    </li>

                    <li
                      id="videos"
                      className={activeMenu == "Videos" ? "active" : ""}
                    >
                      <a href="/Videos">
                        <i className="la la-video"></i> <span>Videos</span>
                      </a>
                    </li>

                    <li
                      id="welcomeSection"
                      className={activeMenu == "WelcomeSection" ? "active" : ""}
                    >
                      <a href="/WelcomeSection">
                        <i className="la la-home"></i>{" "}
                        <span>Welcome Section</span>
                      </a>
                    </li>

                    <li
                      id="VendorTypes"
                      className={activeMenu == "VendorTypes" ? "active" : ""}
                    >
                      <a href="/VendorTypes">
                        <i className="la la-briefcase"></i>{" "}
                        <span>Vendor Types</span>
                      </a>
                    </li>
                    <li
                      id="vendorRequest"
                      className={activeMenu == "vendorRequest" ? "active" : ""}
                    >
                      <a href="/vendorRequest">
                        <i className="la la-envelope"></i>{" "}
                        <span>Vendor Request</span>
                      </a>
                    </li>
                    {/* <li
                      id="RegisteredVendor"
                      className={
                        activeMenu == "RegisteredVendor" ? "active" : ""
                      }
                    >
                      <a href="/RegisteredVendor">
                        <i className="la la-user-plus"></i>{" "}
                        <span>Reg Vendor(Web)</span>
                      </a>
                    </li>
                    <li
                      id="RegisteredVendorMobile"
                      className={
                        activeMenu == "RegisteredVendorMobile" ? "active" : ""
                      }
                    >
                      <a href="/RegisteredVendorMobile">
                        <i className="la la-user-plus"></i>{" "}
                        <span>Reg Vendor(Mob)</span>
                      </a>
                    </li> */}
                    <li
                      id="rentalGuidelines"
                      className={
                        activeMenu == "RentalGuideline" ? "active" : ""
                      }
                    >
                      <a href="/RentalGuideline">
                        <i className="la la-clipboard-list"></i>{" "}
                        <span>Rental Guidelines</span>
                      </a>
                    </li>
                    <li
                      id="rentalHighlights"
                      className={
                        activeMenu == "RentalHighlights" ? "active" : ""
                      }
                    >
                      <a href="/RentalHighlights">
                        <i className="la la-ribbon"></i>{" "}
                        <span>Rental Highlights</span>
                      </a>
                    </li>

                    <li
                      id="rentalCategory"
                      className={
                        activeMenu == "Rental-CategorysandItems" ? "active" : ""
                      }
                    >
                      <a href="/Rental-CategorysandItems">
                        <i className="la la-layer-group"></i>{" "}
                        <span>Rental C & I</span>
                      </a>
                    </li>
                    <li
                      id="decorationCategory"
                      className={activeMenu == "Decoration" ? "active" : ""}
                    >
                      <a href="/Decoration">
                        <i className="la la-box"></i>{" "}
                        <span>Decoration Items</span>
                      </a>
                    </li>
                    <li
                      id="paymentMethods"
                      className={
                        activeMenu == "Payment_Methods" ? "active" : ""
                      }
                    >
                      <a href="/Payment_Methods">
                        <i className="la la-credit-card"></i>{" "}
                        <span>Payment Methods</span>
                      </a>
                    </li>
                    {/* <li
                      id="rentalServiceDetails"
                      className={
                        activeMenu == "RentalServiceDetails" ? "active" : ""
                      }
                    >
                      <a href="/RentalServiceDetails">
                        <i className="la la-cart-plus"></i>{" "}
                        <span>Rental Details</span>
                      </a>
                    </li> */}
                  </>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
      {/* /Sidebar */}
      {/* Page Wrapper */}
      <div className="page-wrapper" style={{ minHeight: "150px" }}>
        {/* Page Content */}
        <div className="content container-fluid">
          <Routes>
            {checkAccess("DASHBOARDVIEW") && (
              <>
                <Route path="/revenue" Component={Revenue} />
                <Route path="/Sales" Component={Sales} />
                <Route path="/Execution" Component={Execution} />
                <Route path="/CountLead" Component={CountsOnLead} />
                <Route
                  path="/CustomerSatisfaction"
                  Component={CustomerStatisfaction}
                />
                <Route path="/RingCentral" exact Component={RingCentralIndex} />
                <Route path="/dashboard" exact Component={Sales} />
              </>
            )}
            {checkAccess("FEEDBACKVIEW") && (
              <Route path="/FeedbackList" exact Component={FeedbackIndex} />
            )}
            {checkAccess("EMAILCONFIGVIEW") && (
              <Route
                path="/email-configuration"
                exact
                Component={ConfigurationPage}
              />
            )}
            {checkAccess("APPCONFIGVIEW") && (
              <>
                <Route
                  path="/app-configuration"
                  exact
                  Component={AppConfigurationPage}
                />
                <Route path="/Banner" exact Component={BannerPage} />
                <Route path="/Gallery_Main" exact Component={Gallery_Main} />
                <Route path="/MyBallroom" exact Component={Myballroom} />
                <Route path="/Testimonials" exact Component={Testimonials} />
                <Route
                  path="/WelcomeSection"
                  exact
                  Component={WelcomeSection}
                />
                <Route
                  path="/UpcomingEvents"
                  exact
                  Component={UpcomingEvents}
                />
                <Route
                  path="/HighlightsAwards"
                  exact
                  Component={HighlightsAwards}
                />
                <Route path="/AboutUs" exact Component={AboutUs} />
                <Route path="/Contact" exact Component={Contact} />
                <Route path="/F-A-Q" exact Component={FAQ} />
                <Route path="/PrivacyTerms" exact Component={PrivacyTerms} />
                <Route path="/Packages" exact Component={Packages} />
                <Route path="/EventTips" exact Component={EventTips} />
                <Route
                  path="/EventTipsImage"
                  exact
                  Component={EventTipsImage}
                />
                <Route path="/EventTipsPage" exact Component={eventTips_Page} />
                <Route path="/Blog" exact Component={Blog} />
                <Route path="/Services" exact Component={Services} />
                <Route path="/Amenities" exact Component={Amenities} />
                <Route
                  path="/VenueHighlights"
                  exact
                  Component={VenueHighlights}
                />
                <Route path="/VendorTypes" exact Component={VendorServices} />
                <Route path="/vendorRequest" exact Component={vendorRequest} />
                <Route
                  path="/RegisteredVendor"
                  exact
                  Component={RequestedVendor}
                />
                <Route
                  path="/RegisteredVendorMobile"
                  exact
                  Component={RegisteredVendorMobile}
                />
                <Route
                  path="/RentalHighlights"
                  exact
                  Component={RentalHighlights}
                />
                {/* <Route path="/Facilities" exact Component={Facilities} /> */}
                <Route path="/FacilityList" exact Component={FacilityList} />
                <Route path="/Videos" exact Component={Videos} />
                <Route
                  path="/RentalServiceDetails"
                  exact
                  Component={RentalServiceDetails}
                />
                <Route
                  path="/RentalGuideline"
                  exact
                  Component={RentalGuideline}
                />
                <Route path="/Settings" exact Component={Settings} />
                <Route
                  path="/Rental-CategorysandItems"
                  exact
                  Component={RentalCandI}
                />
                <Route path="/Decoration" exact Component={Decoration} />
                <Route
                  path="/Payment_Methods"
                  exact
                  Component={Payment_Methods}
                />
              </>
            )}

            <Route path="/MeridianContract" exact Component={ContractPage} />
            <Route path="/ScheduledEventsList" exact Component={TourPage} />
            <Route path="/Report_Index" exact Component={CountonLeadReport} />
          </Routes>
        </div>
        {/* /Page Content */}
      </div>
      {/* /Page Wrapper */}
      <ToastContainer
        autoClose={2000}
        hideProgressBar={true}
        pauseOnHover={false}
        draggable={false}
        closeOnClick={false}
      />
      {/* Delete dialog */}
      <div className="modal custom-modal fade" id="delete-dialog" role="dialog">
        <div className="modal-dialog modal-dialog">
          <div className="modal-content">
            <div className="modal-body">
              <div className="form-header">
                <h3>Delete</h3>
                <p>Are you sure want to delete?</p>
              </div>
              <div className="d-flex justify-content-center align-items-center">
                <div>
                  <Button
                    name={"Cancel"}
                    dataBsDismiss={"modal"}
                    isCancelButton={"true"}
                  />
                </div>
                <div>
                  <Button
                    name={"Delete"}
                    id={"btn-delete-confirm"}
                    dataBsDismiss={"modal"}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
